<template>
<div>
  <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
    <div class="title-h4 mr-r10 vertical-center-box">템플릿 목록</div>
    <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
  </el-row>
  <el-table-wrapper :style="fitHeight ? { height: '100%' } : null" :fit-height="fitHeight" ref="tmplTable" :data="tableData" :total="total"
  :columns="tableColumns" :show-search-tool="showSearchTool" remote pagination :show-custom-header="showCustomHeader" @condition-change="onConditionChange"
    @select="onSelect" @select-all="onSelectAll">
  </el-table-wrapper>
</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import filter from 'lodash/filter';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';
import VirtualServiceSettingAPI from '@/api/settings/virtual/virtual-service-settings';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WTemplateListTable',
  props: {
    height: {
      type: String,
    },
    fitHeight: {
      type: Boolean,
    },
    targetTmplList: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    const tableColumns = [
      {
        align: 'center',
        type: 'selection',
        width: 40,
      },
      {
        prop: 'vmName',
        label: '템플릿명',
        width: '100',
        searchable: true,
        sortable: true,
        remotePro: 'vm_name',
        formatter: defaultFormatter,
      },
      {
        prop: 'hypervisorTypeName',
        label: '하이퍼바이저',
        width: '100',
        searchable: true,
        sortable: true,
        remoteProp: 'bs.basicinfo_subname',
        formatter: defaultFormatter,
      },
      {
        prop: 'virtualcenterName',
        label: '가상화센터명',
        width: '100',
        searchable: true,
        sortable: true,
        remoteProp: 'vvc.virtualcenter_name',
        formatter: defaultFormatter,
      },
      {
        prop: 'osName',
        label: '운영체제',
        searchable: true,
        sortable: true,
        remoteProp: 'atv.attr_value',
        formatter: defaultFormatter,
      },
    ];
    return {
      showSearchTool: false,
      showCustomHeader: true,
      tableData: null,
      tableColumns,
      originTableData: null,
      total: null,
      columnDefault,
      loadKey: null,
    };
  },
  methods: {
    initData() {
      this.clearSelection();
    },
    /**
     * 물리 그룹 관리 대상 데이터를 조회한다.
     * @author najongdang
     * @return {[type]} [description]
     */
    loadData() {
      const tableParams = this.$refs.tmplTable.getParameter();
      VirtualServiceSettingAPI.getVmsTemplateList(tableParams).then((response) => {
        const result = response.data;
        if (result.success) {
          this.tableData = result.data;
          this.total = result.total;
          this.setCheckTemplateTable();
        } else {
          this.tableData = [];
          this.total = 0;
        }
      }).catch(() => {
      });
    },
    /**
     * 테이블 조건 변경 이벤트 핸들러
     * @author najongdang
     * @return {[type]} [description]
     */
    onConditionChange() {
      this.loadData();
    },
    /**
     * 테이블 선택 변경 이벤트 핸들러
     * @author najongdang
     * @param  {[type]} selection [description]
     * @return {[type]}           [description]
     */
    onSelect(selection, row) {
      const targetTmpl = this.targetTmplList.find((tmpl) => (tmpl.vmsObjId === row.vmsObjId));
      if (!isNil(targetTmpl)) {
        this.targetTmplList.splice(this.targetTmplList.indexOf(targetTmpl), 1);
      } else {
        this.targetTmplList.push(row);
      }
    },
    onSelectAll(selection) {
      const tableData = this.tableData;
      tableData.forEach((row) => {
        const targetTmpl = this.targetTmplList.find((tmpl) => (tmpl.vmsObjId === row.vmsObjId));
        if (selection.length > 0) {
          if (isNil(targetTmpl)) {
            this.targetTmplList.push(row);
          }
        } else if (selection <= 0) {
          if (!isNil(targetTmpl)) {
            this.targetTmplList.splice(this.targetTmplList.indexOf(targetTmpl), 1);
          }
        }
      });
    },
    /**
     * 선택된 데이터 배열 반환한다.
     * @author najongdang
     * @return {[type]} [description]
     */
    getSelection() {
      return this.$refs.tmplTable.getTable().selection;
    },
    /**
     * 테이블 행 선택을 토글한다.
     * @author najongdang
     * @param  {[type]} rows [description]
     * @return {[type]}      [description]
     */
    toggleRowSelection(rows) {
      rows.forEach((row) => {
        this.$refs.tmplTable.getTable().toggleRowSelection(row);
      });
    },
    /**
     * 모든 행 선택을 해제한다.
     * @author najongdang
     * @return {[type]} [description]
     */
    clearSelection() {
      this.$refs.tmplTable.getTable().clearSelection();
    },
    setCheckTemplateTable() {
      this.clearSelection();
      this.$nextTick(() => {
        this.tableData.forEach((row) => {
          const targetTmpl = this.targetTmplList.find((tmpl) => (tmpl.vmsObjId === row.vmsObjId));
          if (!isNil(targetTmpl)) {
            this.$refs.tmplTable.getTable().toggleRowSelection(row);
          }
        });
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/VirtualService/ServerImageSetting/popup/components/TemplateListTable.vue